(<strong>{{ review.by }} - {{ review.source }}) </strong>
{{ preview }}
<ng-container *ngIf="more && !showMore">
  ...
  <a mat-button tabindex="0" (click)="showMore = true" (keyup.enter)="showMore = true"
    >(read more)</a
  >
</ng-container>
<ng-container *ngIf="showMore"> {{ more }} </ng-container>
